/*
*
* File JS componente modal cookie
*
*/

// IMPORT UTILITIES JS
//--------------------------------------------------------------------//

const setCookie = (name, value, days, domain)  => {
    let expires = "";
    let cdomain = '';
    if(days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    if (domain) {
        cdomain = ";domain=" + domain;
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/"+ cdomain;
}

const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
} 


//--------------------------------------------------------------------//



// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const modalCookie = () => {
    let buttonsCloseModal = document.querySelectorAll('.im-modal-cookie__close');
    let blockModal  = document.querySelectorAll('.im-modal-cookie');
    let backgroundModal  = document.querySelectorAll('.im-modal-cookie__background');

    if (!blockModal.length) return;

    blockModal.forEach(el => {
        let dataCookieName = el.getAttribute('data-name');

        if (getCookie(dataCookieName) == null)
        {
            el.classList.add('open');
        }
    });

    buttonsCloseModal.forEach(el => {
        el.addEventListener('click', function(evt) 
        {
            evt.preventDefault();
            let dataModal = this.getAttribute('data-modal');
            
            closeThisModal(dataModal);
        });
    });

    backgroundModal.forEach(element => {
        element.addEventListener('click', () => {
            let dataModal = element.closest('.im-modal-cookie').getAttribute('data-modal');
            
            closeThisModal(dataModal);
        })
    });


    /**
    *	Funzione per la chiusura di tutti i modal popup
    *
    */
    const closeThisModal = (data) => {
        let modalToClose = document.querySelector('.im-modal-cookie[data-modal="' + data + '"]');
        let dataCookieExpire = parseInt(modalToClose.getAttribute('data-expire'));
        let dataCookieName = modalToClose.getAttribute('data-name');
        
        document.body.style.overflow = '';
        modalToClose.classList.remove('open');

        setCookie(dataCookieName, 'true', dataCookieExpire);
    }


    /**
    *	Funzione per la chiusura di tutti i modal popup
    *
    */
    const closeAllModal = () => {
        let allModal = document.querySelectorAll('.im-modal-cookie');

        allModal.forEach(el => {
            let dataModal = el.getAttribute('data-modal');
            closeThisModal(dataModal);
        });
    }


    /**
    *	Funzione di gestione chiusura dei modal popup digitando ESC
    *
    */
    const closeAllOnKeyup = (e) => {
        if(e.keyCode === 27)
        {
            closeAllModal();
        }
    }

    document.addEventListener('keyup', closeAllOnKeyup);
}


document.addEventListener('DOMContentLoaded', () => {
    modalCookie();
});

//--------------------------------------------------------------------//